import whitelabelConfigs from '../../whitelabel/whitelabel-config.json';
export const ESPIRA_ICON_CONFIG = {
    SPIRE_PORTALEN_COLOR_GREEN: '#96C120',
    SPIRE_PORTALEN_COLOR_RED: '#CB333B',
    SPIRE_PORTALEN_COLOR_WHITE: '#FFFFFF',
};
// A helper function to get the full whitelabel config
export const getWhitelabelConfig = (id) => whitelabelConfigs[id];
// A helper function to get a config entry from a whitelabel config
export const getConfig = (id, key) => { var _a; return (_a = getWhitelabelConfig(id)) === null || _a === void 0 ? void 0 : _a[key]; };
// A helper function to get an asset from a whitelabel config
export const getAsset = (id, key) => {
    var _a;
    return (_a = getConfig(id, 'assets')) === null || _a === void 0 ? void 0 : _a[key];
};
export const WhitelabelUrl = Object.keys(whitelabelConfigs).reduce((acc, id) => {
    acc[id] = getConfig(id, 'domain');
    return acc;
}, {});
export const WhitelabelMobileUrl = Object.keys(whitelabelConfigs).reduce((acc, id) => {
    acc[id] = getConfig(id, 'app_url_scheme');
    return acc;
}, {});
